import React, { useId } from 'react';

interface AuditoriaInteligenteIconProps {
  /** Lado do ícone (px). */
  size?: number | string;
  className?: string;
  /**
   * `badge` (padrão): logo cheio — quadrado-arredondado roxo com a lupa branca.
   *   Use quando o ícone aparece SOZINHO (ex.: cabeçalho do hub).
   * `glyph`: só o símbolo (lupa + barras) em roxo, sem fundo. Use dentro de um
   *   container colorido (sidebar/home) p/ casar com o padrão dos outros módulos.
   */
  variant?: 'badge' | 'glyph';
}

const GLYPH_COLOR = '#5B49E8';

/** Logo do módulo Auditoria Inteligente. */
export function AuditoriaInteligenteIcon({
  size = 24,
  className,
  variant = 'badge',
}: AuditoriaInteligenteIconProps) {
  // id único por instância — evita colisão do gradiente quando o ícone aparece
  // mais de uma vez na mesma página (sidebar + hub, etc.).
  const gradId = `aiGrad-${useId().replace(/:/g, '')}`;

  if (variant === 'glyph') {
    // Só a marca (lupa + barras), em roxo, sem fundo — para encaixar em círculos
    // coloridos como os ícones dos outros módulos.
    return (
      <svg
        width={size}
        height={size}
        viewBox="31 31 31 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-label="Auditoria Inteligente"
      >
        <g stroke={GLYPH_COLOR} fill="none" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="43.5" cy="43.5" r="10.2" strokeWidth="3" />
          <path d="M51.2 51.2 L58.4 58.4" strokeWidth="3.4" />
          <path d="M39.4 45.6 V42.9" strokeWidth="2.9" />
          <path d="M43.5 45.6 V39.3" strokeWidth="2.9" />
          <path d="M47.6 45.6 V41.7" strokeWidth="2.9" />
        </g>
      </svg>
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Auditoria Inteligente"
    >
      <defs>
        <linearGradient id={gradId} x1="12" y1="12" x2="84" y2="84" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7B6BF3" />
          <stop offset="1" stopColor="#5B49E8" />
        </linearGradient>
      </defs>
      <rect x="4" y="4" width="88" height="88" rx="26" fill={`url(#${gradId})`} />
      <g
        transform="translate(28,28)"
        stroke="#FFFFFF"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="15.5" cy="15.5" r="10.2" strokeWidth="3" />
        <path d="M23.2 23.2 L30.4 30.4" strokeWidth="3.4" />
        <path d="M11.4 17.6 V14.9" strokeWidth="2.9" />
        <path d="M15.5 17.6 V11.3" strokeWidth="2.9" />
        <path d="M19.6 17.6 V13.7" strokeWidth="2.9" />
      </g>
    </svg>
  );
}
